import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GerarPedidoComponent } from './gerar-pedido/gerar-pedido.component';
import { CompraOnlineRoutingModule } from './compra-online-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule, NbActionsModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { ComponentstModule } from '../../shared/components/components.module';
import { CompraOnlineComponent } from './compra-online.component';
import { ListaPedidoComponent } from './consulta-pedido-recebido/lista-pedido/lista-pedido.component';
import { DetalhePedidoComponent } from './consulta-pedido-recebido/detalhe-pedido/detalhe-pedido.component';
import { CadastrarFornecedorComponent } from './consulta-pedido-recebido/detalhe-pedido/cadastrar-fornecedor/cadastrar-fornecedor.component';
import { ListaPedidoAprovadoComponent } from './consulta-pedido-aprovado/lista-pedido-aprovado/lista-pedido-aprovado.component';
import { VisualizaDadosNfComponent } from './consulta-pedido-aprovado/lista-pedido-aprovado/visualiza-dados-nf/visualiza-dados-nf.component';
import { ModalUploadNfComponent } from './consulta-pedido-aprovado/lista-pedido-aprovado/modal-upload-nf/modal-upload-nf.component';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { RelacaoIndustriaComponent } from './relacao-industria/relacao-industria.component';
import { ModalRecebiveisCercComponent } from './consulta-pedido-recebido/detalhe-pedido/modal-recebiveis-cerc/modal-recebiveis-cerc.component';
import { TermoCondicaoComponent } from './termo-condicao/termo-condicao.component';
import { PlataformaPagamentoComponent } from './plataforma-pagamento/plataforma-pagamento.component';

@NgModule({
  imports: [
    CommonModule,
    CompraOnlineRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbActionsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    ComponentstModule,
    NbCheckboxModule,
    NgxMyDatePickerModule.forRoot(),
    CurrencyMaskModule,
  ],
  exports: [
    MyDatePickerModule,
  ],
  declarations: [
    CompraOnlineComponent,
    GerarPedidoComponent,
    ListaPedidoComponent,
    DetalhePedidoComponent,
    CadastrarFornecedorComponent,
    ListaPedidoAprovadoComponent,
    VisualizaDadosNfComponent,
    ModalUploadNfComponent,
    RelacaoIndustriaComponent,
    ModalRecebiveisCercComponent,
    TermoCondicaoComponent,
    PlataformaPagamentoComponent
  ],
  entryComponents:[
    VisualizaDadosNfComponent,
    ModalUploadNfComponent,
    ModalRecebiveisCercComponent,
  ]

})
export class CompraOnlineModule { }
